import { isInNativeShell } from "@/lib/nativeBridge";
import { NativeWelcomeHero } from "@/components/NativeWelcomeHero";
import { LandingPage } from "./LandingPage";

export function UnauthRoot() {
  return isInNativeShell() ? <NativeWelcomeHero /> : <LandingPage />;
}
